import { Carousel } from 'react-bootstrap';

import { useEffect, useState } from 'react';
import { getRequiredProtectedData } from '../../redux/apicalltemplate';
import { userApis } from '../../redux/api';

export const CarouselHome = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const _runEffect = async () => {
      const response = await getRequiredProtectedData(
        'GET',
        `${userApis.BANNER}`,
        {}
      );
      if (response && response.data && response.data.data) {
        setData(response.data.data);
      } else {
        setData(null);
      }
    };
    _runEffect();
  }, []);
  if (!data || data.length === 0) return null;

  return (
    <Carousel className="tm-home-banner">
      {data?.map((el, index) => (
        <Carousel.Item key={index}>
          <img
            className="d-block w-100 car-image"
            src={el.banner[0]}
            alt={el.tag || 'Platform update'}
            style={{ maxHeight: '400px' }}
          />
          <Carousel.Caption
            style={{
              width: 'max-content',
              margin: 'auto',
              padding: '10px',
              borderRadius: '6px',
              backdropFilter: 'blur(5px)',
            }}
          >
            <h3 style={{ fontWeight: 'bold' }}>{el.tag}</h3>
            <p style={{ fontWeight: 'bold' }}>{el.description}</p>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};
